<template>
  <v-container :container="containerClass" fluid>
    <payroll-form mode="edit" :payroll="payroll.data" @cancel="onCancel">
      <template #header>
        <div class="d-flex align-center">
          <v-btn
            icon
            color="primary"
            class="mr-2"
            :href="$route('payrolls.index')"
          >
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
          <h2>Edit {{ payroll.data.code }}</h2>
        </div>
      </template>
    </payroll-form>
  </v-container>
</template>
<script>
import LayoutDashboard from '@layouts/Dashboard'
import PayrollForm from '@components/Payroll/Form'
export default {
  components: {
    PayrollForm,
  },
  layout: LayoutDashboard,
  props: {
    payroll: {
      type: Object,
      required: true,
    },
  },
  methods: {
    onCancel() {
      window.location.href = this.$route('payrolls.index')
    },
  },
}
</script>
